import { Injectable, inject } from '@angular/core';
import { combineLatest, distinctUntilChanged, map, skip, skipWhile } from 'rxjs';

import { standardizeGroupName } from '../../../shared/utils/auth/groups/group-names/standardize-group-name';
import { UserGroupsService } from '../../../shared/utils/auth/groups/user-groups.service';

import { AiChatThreadService } from './ai-chat-thread.service';

/**
 * Resets chat thread state when the effective identity changes (logout, spoof toggle).
 */
@Injectable({ providedIn: 'root' })
export class AiChatIdentityService {
    private readonly userGroups = inject(UserGroupsService);
    private readonly threads = inject(AiChatThreadService);

    constructor() {
        combineLatest([
            this.userGroups.userInfo$.pipe(map((user) => user?.sub ?? '')),
            this.userGroups.userGroups$.pipe(
                map((groups) =>
                    groups
                        .map((group) => standardizeGroupName(group.group))
                        .sort((a, b) => a.localeCompare(b))
                        .join(',')
                )
            ),
        ])
            .pipe(
                map(([sub, groups]) => `${sub}|${groups}`),
                distinctUntilChanged(),
                skipWhile((key) => key.startsWith('|')),
                skip(1)
            )
            .subscribe(() => {
                void this.threads.resetForIdentityChange();
            });
    }
}
